import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AdtaDeviceOverviewContextProvider from "./context/AdtaDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ADTA, adtaMheValidationRoute} from "../../util/RouteConstants";
import {FEATURES, FeatureUtility} from "../../util/FeatureUtility";
import PermissionAlertBanner from "../../commonui/PermissionAlertBanner";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AdtaDevicePage extends Component {
    render() {

        const getADTARoutes = () => {
            return FeatureUtility.getFeatureStatus(FEATURES.IS_MHE_VALIDATION_ENABLED) ? [...ADTA, adtaMheValidationRoute] : ADTA;
        }

        return (
            <Column>
                <PermissionAlertBanner/>
                <AdtaDeviceOverviewContextProvider>
                        <TabLayout routes={getADTARoutes()} location={this.props.location} history={this.props.history}/>
                        <NavigationRoutes routes={getADTARoutes()}/>
                </AdtaDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AdtaDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/AdtaDevicePage.js